// eslint-disable-next-line import/prefer-default-export
import { createSelector } from 'reselect';

export const getSets = ({ sets }) => sets.data.sort((a, b) => {
  if (a.name.toLowerCase() < b.name.toLowerCase()) {
    return -1;
  }

  if (a.name > b.name) {
    return 1;
  }

  return 0;
});

export const getSetsLoadingState = ({ sets }) => sets.loading;
export const getSetsOptions = createSelector(
  getSets,
  (items) => items.map(({ id: value, name: text, color }) => ({ value, text, color })),
);

export const getSetsLabelMap = (previousMapSnapshot = {}) => createSelector(
  getSets,
  (items) => items.reduce((result, { name, id }) => ({ ...result, [id]: name }), previousMapSnapshot),
);
